/**
 * Grid-template helper shared by the nested saved-view renderings (#1144).
 *
 * This file once held the full-width-row flattening machinery for the
 * AG Grid nested mode; that mechanism was replaced by the GroupedTable
 * ledger (see NestedBillTable) and the dead code removed in the review
 * sweep. Only the template builder survives.
 */

import type { SavedViewColumnEntry } from '../../types/savedViews';

/**
 * CSS grid template shared by a header band and its rows, so their columns
 * stay aligned. Widths come from the view's stored column entries; hidden
 * entries are skipped and the last column flexes.
 */
export function subRecordGridTemplate(columns: SavedViewColumnEntry[]): string {
  const visible = columns.filter((c) => !c.hide);
  if (visible.length === 0) return '1fr';
  return visible
    .map((c, i) =>
      i === visible.length - 1
        ? `minmax(${c.width ?? 160}px, 1fr)`
        : `${c.width ?? 160}px`
    )
    .join(' ');
}
